export enum SearchWidgetType {
  Combined = "combined",
  Flights = "flights",
  Hotels = "hotels",
  Packages = "packages",
}
